import { FormattedMessage } from "react-intl";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "@lendcord/concord";
import { getNavItemsForRole } from "@/app/navigation";
import { getRoleFromToken } from "@/app/tokenStorage";

export function Sidebar({ open, onClose }: { open: boolean; onClose: () => void }) {
  const location = useLocation();
  const navItems = getNavItemsForRole(getRoleFromToken());

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 z-10 bg-black/30 md:hidden"
          onClick={onClose}
        />
      )}
      <aside
        className={
          "fixed inset-y-0 left-0 z-20 flex w-60 flex-col border-r border-border bg-surface-raised transition-all duration-200 " +
          // Open: full drawer at any width. Closed: fully off-canvas on
          // mobile (this is chrome, not content — it must not squeeze the
          // page), collapsed to an icon rail only from md: up.
          (open ? "translate-x-0" : "-translate-x-full md:w-20 md:translate-x-0")
        }
      >
        <div
          className={
            "flex items-center border-b border-border py-5 transition-all duration-200 " +
            (open ? "justify-start px-6" : "justify-center px-2")
          }
        >
          {open ? <Logo variant="full" /> : <Logo variant="mark" size="sm" />}
        </div>

        <nav className="flex flex-1 flex-col gap-1 px-2 py-4">
          {navItems.map(({ key, labelId, Icon, path }) => {
            const isActive = location.pathname === path;
            const className = isActive
              ? "flex items-center gap-3 rounded-sm bg-accent-50 px-3 py-2.5 text-sm font-medium text-accent-600 " +
                (open ? "justify-start" : "justify-center")
              : "flex items-center gap-3 rounded-sm px-3 py-2.5 text-sm font-medium text-text-muted hover:bg-surface hover:text-text " +
                (open ? "justify-start" : "justify-center");

            return (
              <Link
                key={key}
                to={path}
                aria-current={isActive ? "page" : undefined}
                className={className}
              >
                <Icon className="h-5 w-5 shrink-0" />
                <span className={open ? "" : "hidden"}>
                  <FormattedMessage id={labelId} />
                </span>
              </Link>
            );
          })}
        </nav>
      </aside>
    </>
  );
}
